/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import reduceRight from 'lodash/reduceRight'
import React from 'react'

const wrapProvider = (Provider, children) => <Provider>{children}</Provider>

const wrapProviders = providers => {
  return ({children}) =>
    reduceRight(providers, (wrapped, provider) => wrapProvider(provider, wrapped), children)
}

export {wrapProviders as default}
